import { type CaseHit } from '~/types.ts'

function vendor(hit: CaseHit): void {
  hit.data.vendor = dataSourceVendor(hit.data_source_id)
}

function caseHitInData(hit: CaseHit): void {
  hit.data = Object.assign({}, hit.data)
  hit.data.case_hit = hit
}

function caseHitInUpdate(hit: CaseHit): void {
  hit.update = Object.assign({}, hit.update)
  hit.update.case_hit = hit
}

function hitTransformations(hit: CaseHit): CaseHit {
  hit = Object.assign({}, hit)

  caseHitInData(hit)
  vendor(hit)

  if (hit.update) {
    caseHitInUpdate(hit)
  }

  return hit
}

export { hitTransformations }
